import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Button } from "@/components/ui/button";
import { X } from "lucide-react";
import { Link } from "react-router-dom";

const PRIVACY_ACCEPTED_KEY = "privacy_accepted";

export function PrivacyBanner() {
  const { t } = useTranslation();
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const accepted = localStorage.getItem(PRIVACY_ACCEPTED_KEY);
    if (!accepted) {
      setIsVisible(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem(PRIVACY_ACCEPTED_KEY, "true");
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 p-4 bg-card border-t border-border shadow-lg">
      <div className="max-w-4xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-4">
        <div className="text-sm text-muted-foreground text-center sm:text-left">
          <p>
            {t("privacy.bannerText", "We respect your privacy. We don't collect personal data or sell your information.")}{" "}
            <Link to="/terms" className="text-primary underline hover:no-underline">
              {t("privacy.learnMorePrivacy", "Learn more about our privacy policy")}
            </Link>
          </p>
        </div>
        <div className="flex items-center gap-2">
          <Button 
            onClick={handleAccept} 
            size="sm"
            className="whitespace-nowrap"
          >
            {t("privacy.gotIt", "Got it")}
          </Button>
          <Button
            variant="ghost"
            size="icon"
            onClick={handleAccept}
            className="h-8 w-8"
          >
            <X className="h-4 w-4" />
          </Button>
        </div>
      </div>
    </div>
  );
}
